module.exports = __webpack_public_path__ + "static/img/mujer.7541a75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mujer.png
// module id = 3MF8
// module chunks = 5